import React, { useContext } from 'react';
import { Text, Button, Feedback } from 'react-onei';

import TagService from '../../../services/TagService';
import ConfidentialMessage from './ConfidentialMessage';
import { events } from '../../../conf/tags_ga.conf';

import UserContext from '../../../context/UserContext';
import Popin from '../../Popin/Popin';

function ConfirmView() {
  const { wording, serviceConf } = useContext(UserContext);
  const { authUrl, redirectUrl } = serviceConf;
  const { WLOST_600, WLOST_601, WLOST_603 } = wording;
  const description = <span dangerouslySetInnerHTML={{ __html: WLOST_601 }}></span>;

  function handleClick() {
    switch (serviceConf.dictionary) {
      case 'multibal':
        TagService.sendEvent(events.backToManageBal);
        break;
      case 'recovery':
        TagService.sendEvent(events.unlockCompromisedAccount);
        break;
      default:
        TagService.sendEvent(events.auth);
        break;
    }

    window.location.href = authUrl || redirectUrl;
  }

  return (
    <Feedback id="confirm" variant="success" title={WLOST_600} className="spacing-s no-spacing-mobile">
      <Text
        id="confirmation-service-help"
        variant="lead"
      >
        { description }
      </Text>
      <Button id="auth-button" onClick={handleClick} className="spacing-xs">
        {WLOST_603}
      </Button>
      {serviceConf.dictionary !== 'multibal' && <ConfidentialMessage />}
      <Popin />
    </Feedback>
  );
}

export default ConfirmView;
